import React, { useState, useEffect, useRef } from "react";
import { Checkbox as MUICheckbox, FormControlLabel } from "@mui/material";
import { useApp } from "context";

type Props = {
  sx?: any;
  id?: number;
  name?: string;
  label: string;
  checked?: boolean;
  required?: boolean;
  disabled?: boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
    value?: number
  ) => void;
};

export const Checkbox = (props: Props) => {
  const { theme } = useApp();

  const [checked, setChecked] = useState(props.checked ?? false);

  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }
    setChecked(props.checked ?? false);
  }, [props.checked]);

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    props.onChange && props.onChange(event, checked, props.id);
    setChecked(checked);
  };

  return (
    <FormControlLabel
      sx={{
        "& .MuiFormControlLabel-label": {
          "&.Mui-disabled": { color: theme.disabled.color },
          ...props.sx,
        },
      }}
      control={
        <MUICheckbox
          value={true}
          name={props.name}
          onChange={handleChange}
          checked={checked}
          required={!!props.required}
          disabled={!!props.disabled}
          sx={{
            color: theme.palette.font.color,
            "&.Mui-disabled": { color: theme.disabled.color },
          }}
        />
      }
      label={props.label}
    />
  );
};
